import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const AddressDetailsAction = createAsyncThunk(
  "AddressDetailsAction",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/UpdateAddress",
        data1,
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);
const AddressDetailsSlice = createSlice({
  name: "AddressDetails",
  initialState: {
    isLoading: "hide",
    isSuccessFull:false
  },
  reducers: {
    AddressResetAction(state, action) {
        state.isSuccessFull=false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddressDetailsAction.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isSuccessFull=true;
      })
      .addCase(AddressDetailsAction.pending, (state, action) => {
        state.isLoading = "";
      })
  },
});
export const {AddressResetAction} = AddressDetailsSlice.actions;
export default AddressDetailsSlice.reducer;
